const ParentsRegistrationLetters = `
<style>
  .step-two-lines {
    font-size: 9pt;
    margin: 0;
    line-height: 1.3;
    white-space: nowrap; /* only <br> can break the line */
  }

  #contact {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: left;
    gap: 4px;
  }

  #contact .contact-title {
    font-weight: bold;
    margin: 0;
  }

  #contact .contact-phone {
    font-size: 24pt;
    font-weight: bold;
    line-height: 1;
    margin: 0;
  }

  @media print {
    @page {
      margin: 8mm 8mm;
      size: A4 portrait;
    }
    
    body {
      margin: 0;
      padding: 0;
      font-size: 8.5pt;
      line-height: 1.2;
    }
    
    .print-container {
      margin: 0 !important;
      padding: 3mm !important;
      max-width: 100% !important;
      width: 100% !important;
      box-sizing: border-box;
      page-break-after: avoid;
      page-break-inside: avoid;
    }
    
    .step-section {
      page-break-inside: avoid;
    }
    
    /* Reduce spacing for print */
    .print-container h1 {
      font-size: 18pt !important;
      margin-bottom: 10pt !important;
      line-height: 1.2 !important;
    }
    
    .print-container .step-section {
      margin-bottom: 4px !important;
    }
    
    .print-container footer {
      padding-top: 2px !important;
      margin-top: 4px !important;
    }
    
    /* Compact images */
    .print-container img {
      max-width: 100%;
      height: auto;
    }
    
    /* Reduce padding in step sections */
    .print-container .step-section > div {
      padding: 4px 6px !important;
    }
    
    /* Reduce all margins and padding */
    .print-container p {
      margin: 2px 0 !important;
      line-height: 1.3 !important;
    }

    #contact {
      gap: 2px;
      margin-top: 1px;
    }

    #contact p {
      margin: 0 !important;
      line-height: 1 !important;
    }
    
    .print-container > div:first-child {
      margin-bottom: 8px !important;
    }
    
    .print-container > div > div {
      margin-bottom: 8px !important;
    }
    
    /* Compact dashed borders */
    .print-container > div > div[style*="dashed"] {
      margin: 4px 0 !important;
    }
  }
  
  @media screen {
    .print-container {
      margin: 60px auto;
      max-width: 960px;
    }
  }
</style>

<div class="print-container">
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
    <p style="flex: 1; text-align: center; font-weight: bold; font-size: 10pt;">{{title}}</p>
    <img
      src="/images/plan_selection_guide_logo.png"
      alt="イロドキ ロゴ"
      style="width: 96px; height: auto; margin-left: 16px;"
    />
  </div>
  <h1 style="font-size: 30px; text-align: center; font-weight: bold; margin-bottom: 1em;">
    写真共有アプリ『イロドキ』利用登録のご案内
  </h1>
  <div style="margin-bottom: 20px;">
    <p style="font-size: 10pt; margin-bottom: 0px;">
      『イロドキ』は園で過ごすお子さま一人ひとりのわくわくドキドキした様子を選び届けるスマホアプリです。
      <br />
      ご利用には登録が必要です。つきましては、以下の手順に沿ってアプリのインストールとご登録をお願いいたします。
    </p>
    <p style="font-size: 10pt; margin-top: 0px;">※登録及び基本利用は無料です。</p>
  </div>
  <div>
    <div class="step-section" style="border: 1px solid black; border-radius: 8px; margin-bottom: 12px;">
      <div style="display: flex; align-items: center; background-color: black; padding: 8px 12px; border-radius: 6px 6px 0 0;">
        <div style="padding: 4px 8px; color: black; font-weight: bold; background-color: white; border-radius: 9999px; display: inline-block; font-size: 11pt;">
          STEP1
        </div>
        <h2 style="flex: 1; font-size: 16pt; font-weight: bold; color: white; margin: 0 0 0 8px;">
          イロドキアプリをインストールし起動
        </h2>
      </div>
      <div style="display: flex; padding: 8px; gap: 16px;">
        <div style="display: flex; align-items: center; gap: 8px; font-size: 10pt;">
          <img
            alt="logo"
            src="/images/irodoki_app_icon.jpg"
            style="width: 96px; height: 96px;"
          />
          <div style="display: flex; flex-direction: column;">
            <p style="text-align: center; margin: 0;">▼ iPhone</p>
            <img
              alt="app_store_qr"
              src="/images/app_store_qr.jpg"
              style="width: 96px; height: 96px;"
            />
          </div>
          <div style="display: flex; flex-direction: column;">
            <p style="text-align: center; margin: 0;">▼ Android</p>
            <img
              alt="app_store_qr"
              src="/images/google_play_qr.jpg"
              style="width: 96px; height: 96px;"
            />
          </div>
        </div>
        <p style="font-size: 11pt; flex: 1; margin: 0;">
          お使いの端末で写真共有アプリ『イロドキ』をインストール
          してください。
        </p>
      </div>
    </div>
    <div class="step-section" style="border: 1px solid black; border-radius: 8px; margin-bottom: 12px;">
      <div style="display: flex; align-items: center; background-color: black; padding: 8px 12px; border-radius: 6px 6px 0 0;">
        <div style="padding: 4px 8px; color: black; font-weight: bold; background-color: white; border-radius: 9999px; display: inline-block; font-size: 11pt;">
          STEP2
        </div>
        <h2 style="flex: 1; font-size: 16pt; font-weight: bold; color: white; margin: 0 0 0 8px;">
          お子さまの専用コード読み取り、生年月日で照合
        </h2>
      </div>
      <div style="padding: 16px; font-size: 10pt;">
        <div style="display: flex; gap: 24px; align-items: start; justify-content: center; margin: 16px 0;">
          <img
            src="/images/scan_area.png"
            alt="scan area"
            style="width: 160px; border: 1px solid #d1d5db;"
          />
          <div style="display: flex; flex-direction: column; flex: 1;">
            <p style="margin: 0 0 8px 0; font-size: 11pt;">
              イロドキアプリの「新規登録はこちら」から、お子さま専用コードを読み取ります。その後、お子さまの生年月日で照合します。
            </p>
            <hr style="border: none; border-top: 1px solid black; margin: 8px 0;" />
            <div style="margin-bottom: 16px;">
              <span style="font-weight: bold; font-size: 16pt;">{{title}}</span>
            </div>
            <div style="display: flex; gap: 16px;">
              <img
                src="{{qrcode}}"
                alt="QR Code"
                style="width: 128px; height: 128px; border: 1px solid #d1d5db;"
              />
              <div style="display: flex; flex-direction: column; justify-content: center; flex: 1;">
                <span style="font-size: 10.5pt; margin-bottom: 8px;">
                  このコードで登録できる保護者は1人です。
                </span>
                <div style="border: 1px solid black; padding: 12px; text-align: center; margin-bottom: 8px;">
                  <p style="font-size: 14pt; color: black; font-weight: bold; margin: 0; white-space: nowrap; line-height: 1.2;">
                    登録期限 {{date}}
                  </p>
                </div>
                <div style="font-size: 6pt;">
                  <p style="margin: 0px;">
                    ※有効期限切れの場合は、施設から新しい専用コードをお受け取りください。
                  </p>
                  <p style="margin: 0px;">
                    ※2人目のお子さまはアカウント登録後の「設定」から追加できます
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="step-section" style="border: 1px solid black; border-radius: 8px; margin-bottom: 12px;">
      <div style="display: flex; align-items: center; background-color: black; padding: 8px 12px; border-radius: 6px 6px 0 0;">
        <div style="padding: 4px 8px; color: black; font-weight: bold; background-color: white; border-radius: 9999px; display: inline-block; font-size: 11pt;">
          STEP3
        </div>
        <h2 style="flex: 1; font-size: 16pt; font-weight: bold; color: white; margin: 0 0 0 8px;">
          画面にしたがって保護者情報とお子さまの顔写真を登録
        </h2>
      </div>
      <div style="padding: 16px; font-size: 10pt;">
        <div style="display: flex; align-items: center; justify-content: space-around;">
          <div style="display: flex; align-items: center; gap: 4px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              1
            </div>
            <p class="step-two-lines">
              保護者の方の情報<br />を登録
            </p>
          </div>
          <svg style="width: 48px; height: 48px; color: #9ca3af;" fill="currentColor" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>
          <div style="display: flex; align-items: center; gap: 4px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              2
            </div>
            <p class="step-two-lines">
              確認コードメール<br />を受信
            </p>
          </div>
          <svg style="width: 48px; height: 48px; color: #9ca3af;" fill="currentColor" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>
          <div style="display: flex; align-items: center; gap: 4px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              3
            </div>
            <p class="step-two-lines">
              確認コードを入力し<br />登録完了
            </p>
          </div>
          <svg style="width: 48px; height: 48px; color: #9ca3af;" fill="currentColor" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>
          <div style="display: flex; align-items: center; gap: 4px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              4
            </div>
            <p class="step-two-lines">
              お子さまの顔写真<br />を登録
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="step-section" style="border: 1px solid black; border-radius: 8px; margin-bottom: 12px; position: relative;">
      <div style="display: flex; align-items: center; background-color: black; padding: 8px 12px; border-radius: 6px 6px 0 0;">
        <div style="padding: 4px 8px; color: black; font-weight: bold; background-color: white; border-radius: 9999px; display: inline-block; font-size: 11pt;">
          STEP4
        </div>
        <h2 style="flex: 1; font-size: 16pt; font-weight: bold; color: white; margin: 0 0 0 8px;">
          ご利用プランの選択
        </h2>
      </div>
      <div style="display: flex; justify-content: space-between; padding: 16px; font-size: 10pt;">
        <div style="display: flex; align-items: center; justify-content: center; gap: 16px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              1
            </div>
            <p class="step-two-lines">
              イロドキアプリ上の「設定」<br />からプランページにログイン
            </p>
          </div>
          <svg style="width: 48px; height: 48px; color: #9ca3af;" fill="currentColor" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>
          <div style="display: flex; align-items: center; gap: 8px;">
            <div style="width: 32px; height: 32px; background-color: black; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18pt; font-weight: bold;">
              2
            </div>
            <p class="step-two-lines">
              「プラン」のタブから各プラン<br />の詳細確認・お申し込み
            </p>
          </div>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <p style="font-weight: bold; text-align: center; margin: 0;">プランの詳細は裏面を確認</p>
          <svg style="width: 14px; height: 14px;" fill="currentColor" viewBox="0 0 512 512"><path d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"/></svg>
        </div>
      </div>
    </div>
    <footer style="display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; padding-top: 12px; font-size: 10pt;">
      <img
        src="/images/sakura_logo.png"
        alt="サクラクレパス ロゴ"
        style="height: 32px;"
      />
      <div id="contact">
        <p class="contact-title">イロドキサポート事務局</p>
        <p class="contact-phone">06-4967-1283</p>
      </div>
      <p style="text-align: center; margin: 0;">受付時間 9：00 - 17：00（土日祝除く）</p>
    </footer>
  </div>
</div>`;

export default ParentsRegistrationLetters;
